import { LoaderScreen } from '@/components/Elements';
import clsx from 'clsx';

interface SavedFiltersCountProps {
  count: number;
  max: number;
  loading: boolean;
  className?: string;
}

export const SavedFiltersCount = ({
  count,
  max,
  loading,
  className,
}: SavedFiltersCountProps) => {
  if (loading) {
    return (
      <div
        className={clsx(
          'rounded-xl bg-rw-light-gray px-2 text-sm text-rw-dark-gray',
          className
        )}
      >
        <LoaderScreen className="mr-2 size-4" contained />
      </div>
    );
  }

  const countText = `${count}/${max}`;

  return (
    <div
      className={clsx(
        'rounded-xl bg-rw-light-gray px-2 text-sm text-rw-dark-gray',
        className
      )}
    >
      {countText}
    </div>
  );
};
